import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  position: relative;
`

export const Subheader = styled.div`
  color: var(--text-primary);
  font-size: var(--font-size-300);
`
